import { render, staticRenderFns } from "./ziYangDataCenter.vue?vue&type=template&id=79ab8318&scoped=true&"
import script from "./ziYangDataCenter.vue?vue&type=script&lang=ts&"
export * from "./ziYangDataCenter.vue?vue&type=script&lang=ts&"
import style0 from "./ziYangDataCenter.vue?vue&type=style&index=0&id=79ab8318&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ab8318",
  null
  
)

export default component.exports